import {
  LOAD_API_SERVICE_DETAIL_DATA,
  LOAD_API_SERVICE_DETAIL_FAILED,
  LOAD_API_SERVICE_DETAIL_SUCCESS,
} from "../types"

const initialState = {
  destination: [],
  loading: false,
  error: false,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case LOAD_API_SERVICE_DETAIL_DATA:
      return {
        ...state,
        loading: true,
        error: false,
        destination: [],
      }
    case LOAD_API_SERVICE_DETAIL_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
        destination: [],
      }
    case LOAD_API_SERVICE_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        destination: action.payload,
      }
    default:
      return state
  }
}
  